import { Injectable } from "@angular/core";
import { Role } from "src/app/interfaces";
import { LogClass, Logger } from "src/app/logger";

export abstract class AbstractAuthorizationService {
  public abstract update(roles: Role[]): void;
  public abstract isAdmin(roles: Role[]): boolean;
  public abstract isUnknown(roles: Role[]): boolean;
  public abstract isServiceDesk(roles: Role[]): boolean;
}

@LogClass()
@Injectable({
  providedIn: "root"
})
export class MockAuthorizationService implements AbstractAuthorizationService {
  private logger: Logger;

  constructor() {
    this.logger.debug("ctor");
  }
  public update(roles: Role[]): void {
    this.logger.info(roles.toString());
  }
  public isAdmin(roles: Role[]): boolean {
    return roles.filter((x) => x.name === "admin").length > 0;
  }
  public isServiceDesk(roles: Role[]): boolean {
    return roles.filter((x) => x.name === "serviceDesk").length > 0;
  }
  public isUnknown(roles: Role[]): boolean {
    return roles.filter((x) => x.name === "isUnknown").length > 0;
  }
}
